<template>
  <div>
    <!-- <div><img :src="firstBanner" alt="" width="100%"></div> -->
    <h3 style="font-size:20px;padding-top:10px;color:#01b983">欢迎登录展商服务平台！</h3>
    <el-card class="box-card">
      <div style="display:flex;">
        <div style="width:40%">
          <div class="text item"><span class="nameText">公司名称</span> <span>{{ userInfo.atrName }}</span></div>
          <div class="text item"><span class="nameText" style="letter-spacing:5px">展位号</span><span>{{ userInfo.bthCode || '暂无' }}</span></div>
          <div class="text item"><span class="nameText">展位面积</span>
            <template v-if="userInfo.bthArea">
             <span>{{userInfo.bthArea}} m<sup>2</sup></span>
            </template>
            <template v-else>
            <span>暂无</span>
            </template>
          </div>
          <div class="text item"><span class="nameText">展位类型</span> <span>{{ userInfo.bthType || '暂无' }}</span></div>
        </div>
        <div>
          <div class="text item"><span class="nameText">客户经理</span><span>{{ userInfo.atrSaleName || '暂无' }}</span></div>
          <div class="text item"><span class="nameText">电<span style="display:inline-block;width:28px"></span>话</span><span>{{ userInfo.atrTel || '暂无' }}</span></div>
          <div class="text item"><span class="nameText">邮<span style="display:inline-block;width:28px"></span>箱</span><span>{{ userInfo.atrEmail || '暂无' }}</span></div>
        </div>
      </div>   
    </el-card>
    <ul>
      <li>
        <p style="font-weight:bold">衷心感谢您参加CAC2025展览会及其分题展：中国国际植保展览会（CropProtection）、新型肥料展览会（FSHOW）、农化装备及植保器械展览会（CACE）、现代农业科技展览会（AgTech）。</p>
        <p>展商服务平台现已开通，帮助您更好地准备展前工作。该系统提供的服务有：</p>
        <ol style="font-weight:bold;padding:16px 0">
          <li @click="toLink('/magezine')">1.电子会刊信息</li>
          <li @click="toLink('/product')">2.主要产品</li>
          <li @click="toLink('/card')">3.参展证申请</li>
          <li @click="toLink('/inviteCode')">4.企业名片</li>
          <li @click="toLink('/hotel')">5.酒店预定</li>
        </ol>
      </li>
      <li style="font-weight:bold">为确保您顺利参展，请阅读平台相关信息，并遵守各项服务的截止日期，部分标有“必填”字样的内容请优先填写。如有任何疑问，请与您的客户经理联系，我们将竭诚为您提供更详尽的服务和指导。</li>
      <li style="font-weight:bold">我们期待着您的到来。祝您在展会上取得成功！</li>
      <li style="font-weight:bold;color:red">为确保信息更新成功，请在做出修改后即刻点击保存按钮，若60分钟未操作，系统将自动退出</li>
      <br />
      <div class="imporTip">今天是{{ today }}， 距离展会开幕还有 {{ inDays }} 天。</div>
    </ul>
    <el-divider></el-divider>
    <el-table :data="infoTable" style="width: 100%;padding-bottom:150px" stripe :span-method="objectSpanMethod">
      <el-table-column prop="fstName" label="项目" align="center">
        <template slot-scope="scope">
          <span @click="tableLink(scope.row)" style="cursor: pointer" v-if="scope.row.fstName == '产品类别'">主要产品</span>
          <span @click="tableLink(scope.row)" style="cursor: pointer" v-else-if="scope.row.fstName == '会刊信息'">电子会刊信息</span>
          <span @click="tableLink(scope.row)" style="cursor: pointer" v-else-if="scope.row.fstName == '新品上传'">产品图片上传</span>
          <span @click="tableLink(scope.row)" style="cursor: pointer" v-else>{{ scope.row.fstName }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="重要性" align="center">
        <template slot-scope="scope">
          <span style="color:red">{{ scope.row.isRequired ? '必填项' : '非必填' }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <!-- <span style="color:red">{{ scope.row.isRequired ? '已提交' : '未提交' }}</span> -->
          <span style="color:red">{{ scope.row.subDate ? '已提交' : '未提交' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fstEDate" label="说明" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.fstName == '参展证申请'"><!-- {{ format(scope.row.fstEDate) }} -->2025-03-16前完成</span>
          <!-- <span v-if="scope.row.fstName == '会刊信息'">特别提示：本届展会将不再印刷纸质会刊，提交或修改的会刊内容，将会收录在电子会刊中！您可通过我们的官方网站、自媒体平台以及专属的移动小程序，随时随地访问到最新的会刊内容。</span> -->
          <span v-if="scope.row.fstName == '产品类别' || scope.row.fstName == '新品上传' || scope.row.fstName == '会刊信息'">特别提示：本届展会将不再印刷纸质会刊，提交或修改的主要产品，将会收录在电子会刊中！提交电子会刊时的公司名称将用于制作展商名录一包括展会官网、现场的展商名录以及展位楣板。名录 / 楣板的截止日期是2025年2月20日。</span>
        </template>
      </el-table-column>
      <el-table-column prop="subDate" label="提交日期" align="center">
        <template slot-scope="scope">
          <span>{{ format(scope.row.subDate) }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import api from '@/api'
import moment from 'moment'
import firstBanner from '@/assets/firstBanner.jpg'
import tools from '@/utils/tools';
moment.locale('zh-cn')
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      exhInfo: {},
      today: moment().format('YYYY年MM月DD日'),
      inDays: '',
      infoTable: [],
      firstBanner:firstBanner
    }
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //当前行row、当前列column、当前行号rowIndex、当前列号columnIndex
      if (columnIndex === 2) {
        if (rowIndex === 1) {
          return {
            rowspan: 3,
            colspan: 1
          };
        } else if (rowIndex === 2 || rowIndex === 3) {
          return {
            rowspan: 0,
            colspan: 0
          };
        } else {
          return {
            rowspan: 1,
            colspan: 1
          };
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1
        };
      }
    },
    format(data) {
      if (data !== null){
        return moment(data).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    toLink(url){
      // console.log(url)
      this.$router.push(url)
    },
    tableLink(obj){
      var url = ''
      if(obj.fstName == '会刊信息'){
        url = '/magezine'
      }
      if(obj.fstName == '产品类别'){
        url = '/product'
      }
      if(obj.fstName == '参展证申请'){
        url = '/card'
      }
      if(obj.fstName == '新品上传'){
        url = '/productList'
      }
      this.$router.push(url)
    }
  },
  mounted() {
    api.getexhinfo().then((res) => {
      // this.inDays = moment(res.data.data.exhbtime).toNow(true)
      this.inDays = moment(res.data.data.exhbtime).diff(new Date(), 'day')
      // console.log(moment(res.data.data.exhbtime).diff(new Date(), 'month','day'))
      // console.log(moment('2024-03-01 00:00:00').diff(new Date(), 'month','day'))
    })

    api.getformsetting().then((res) => {
      var _temp = res.data.data
      this.infoTable =  _temp // .sort(function(data1,data2){
      //   if(new Date(data1.fstEDate).getTime() > new Date(data2.fstEDate).getTime()){
      //     return 1
      //   }else{
      //     return -1
      //   }  
      // })
      // this.infoTable = _temp
      // console.log(this.infoTable )
    })
  },
}
</script>

<style lang="less" scoped>
.box-card {
  margin: 20px 0 20px 0;
}
.item {
  padding: 10px 0;
  font-size:14px
}
.item .nameText{
  font-weight: normal;
  display: inline-block;
  width:60px;
  text-align:right;
  margin-right: 10px;
}
.item span{
  font-weight: bold;
}
li, strong {
  line-height: 2;
  font-size:14px;
}
.page-warp h3{
  font-size:14px
}
.imporTip{
  padding:10px 20px;font-size:18px;color:#01b983;font-weight: bold;
  background: #d0eadb linear-gradient(135deg, #d0eadb 0%, #fff 100% );
  border-radius:10px;
}
li{
  cursor: pointer;
}
@media screen and (max-width:540px){

}
</style>
